/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  ScrollView,
} from 'react-native';
import RenderHtml from 'react-native-render-html';

import Header from '../../components/misc/Header';
import styles from '../../styles';
import { translate } from '../../locales/i18n';

class Privacy extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Privacy';
  }

  render() {
    const { history } = this.props;

    const html = translate('company_privacy');

    return (
      <View
        style={styles.view.headed}
      >
        <Header
          name={translate('menu_privacy')}
          hasCancel
          history={history}
        />

        <ScrollView
          style={{
            flex: 1,
            width: '100%',
            alignSelf: 'center',
          }}
        >
          <RenderHtml
            containerStyle={{
            }}
            source={{ html }}
          />
        </ScrollView>
      </View>
    );
  }
}

Privacy.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default Privacy;
